// extracted by mini-css-extract-plugin
export default {"toolsCategories":"tabs_toolsCategories__xTelz","toolsCategory":"tabs_toolsCategory__eWRu4","toolsCategory__active":"tabs_toolsCategory__active__7dHtE"};